/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ExternalContainerLocation_container = {
    readonly slug: string;
    readonly physicalStatus: string | null;
    readonly validPhysicalStatuses: ReadonlyArray<{
        readonly value: string;
        readonly title: string;
    }>;
    readonly " $refType": "ExternalContainerLocation_container";
};
export type ExternalContainerLocation_container$data = ExternalContainerLocation_container;
export type ExternalContainerLocation_container$key = {
    readonly " $data"?: ExternalContainerLocation_container$data;
    readonly " $fragmentRefs": FragmentRefs<"ExternalContainerLocation_container">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ExternalContainerLocation_container",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "physicalStatus",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ExternalValidPhysicalStatus",
      "kind": "LinkedField",
      "name": "validPhysicalStatuses",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "value",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ExternalContainer",
  "abstractKey": null
};
(node as any).hash = '89d85daff35c816655f113e346e804ce';
export default node;
